import { getValueForTimeInput } from "../../utils/getValueForTimeInput.js";
import { DateTime } from "../../utils/luxon.js";
import { maxOrderHour, maxOrderMinute, minOrderHour, minOrderMinute, orderTimeStepInSeconds } from "../orderTimes.js";

export function getAvailableDeliveryTimes(nearestDelivery: Date | string, selectedDelivery: Date | string): string[] {
	const nearestDeliveryDate = DateTime.fromJSDate(new Date(nearestDelivery));
	const selectedDeliveryDate = DateTime.fromJSDate(new Date(selectedDelivery));

	if (selectedDeliveryDate.startOf("day") < nearestDeliveryDate.startOf("day")) {
		return [];
	}

	let start = nearestDeliveryDate;

	if (selectedDeliveryDate.startOf("day") > nearestDeliveryDate.startOf("day")) {
		start = nearestDeliveryDate.set({
			hour: minOrderHour,
			minute: minOrderMinute,
			second: 0,
			millisecond: 0,
		});
	}

	const end = start.set({
		hour: maxOrderHour,
		minute: maxOrderMinute,
		second: 0,
		millisecond: 0,
	});

	const availableTimes: string[] = [];
	for (let time = start; time <= end; time = time.plus({ second: orderTimeStepInSeconds })) {
		availableTimes.push(getValueForTimeInput(time.toJSDate()));
	}
	return availableTimes;
}
